import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
//import 'font-awesome/css/font-awesome.css';
import './adminTable.css';
import moment from 'moment';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"; 
import Button from 'react-bootstrap/Button';
import AdminModelPop from '../adminModelPop/adminModelPop'
import AdminDeletePopup from '../adminModelPop/adminDeletePop'
import { Link,Redirect } from 'react-router-dom';
class AdminTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            pageSize: 10,
            records: 0,
            sortColumnName: '',
            sortOrder: '',
            blocking: true,
            adminData: [],
           // selectedEditData:{},
            showEditor: false,
            editorProps: null
        }
        this.columnFormatter=this.columnFormatter.bind(this);
        this.buttonFunction=this.buttonFunction.bind(this);
    }

    pageChanged(pageNumber) {
        this.setState({ pageNumber: pageNumber });
        this.setState({currentPage:pageNumber});
         this.props.paginationHandler(pageNumber, this.state.pageSize, this.state.sortColumnName, this.state.sortOrder);
    }

    sortChanged(sortColumn, order) {
        this.setState({ sortColumnName: sortColumn });
        this.setState({ currentPage: 1 });
        let sortOrder = order.toString().toLowerCase() === 'asc' ? 'desc' : 'asc';
        this.setState({ sortOrder: sortOrder });
        this.props.paginationHandler(this.state.pageNumber, this.state.pageSize, sortColumn, sortOrder);
    }
    sizePerPageListChange(sizePerPage) {
        this.setState({ pageSize: sizePerPage });
        this.props.paginationHandler(this.state.pageNumber, sizePerPage, this.state.sortColumnName, this.state.sortOrder);
    }
    renderShowsTotal(start, to, total) {
        console.log('start:',start,'to:',to,'total:',total);
        var text = "Showing " + start + " to " + to + " of " + this.state.records + " records.";
        return (
            <p style={{ color: '#007bff' }}>
                {text}
            </p>
        );
    }
    componentWillReceiveProps(nextProps) {
        console.log("NextProps Admin:",nextProps)
        if(nextProps.auditorData){
            this.setState({ adminData: nextProps.auditorData});
            this.setState({records:nextProps.auditorData.totalElements});
        }
    }
  
    columnFormatter(cell,row) {
        console.log(cell,'----',row);
            return <div className="action-buttons-container">
                <a href="#" onClick={this.onEditClick(cell)}><i className="fa fa-edit"></i></a>
                <a href="#" onClick={this.deleteAdminRow}><i className="fa fa-remove"></i></a>
            </div>
    }
    
    buttonFunction(cell,row) {
        console.log(cell,'----',row)
        return <div className="action-buttons-container">
        <label>
        <button type="button" 
                id="validatebutton" 
                onClick={() => {this.onEditClick(row)}} 
                className="bbtn btn-primary btn-sm">
                  Edit
        </button>
     </label>
     <label>
         <button type="button" 
                id="validatebutton" 
                onClick={() => {this.onDeleteClick(row)}} 
                className="bbtn btn-primary btn-sm"
                style={{marginLeft:"6px"}}>
                 Delete
        </button>
         </label> 
         </div>       
    }
    handleOnSelect = (row)=>{
        console.log('rowAuditor:',row)
        
    }

     selectRowProp = {
         mode:'button',
          onSelect: this.handleOnSelect,
     };
    onAddClick = () =>{
        this.setState({openDialog:true,dialogFor:"ADD"})
    }    
    closePopup=()=>{
        this.setState({openDialog:false,deleteDialog:false})
    }
    onEditClick = (row) =>{
        console.log('EditClick----------',row);
        this.setState({openDialog:true,dialogFor:"EDIT"});
        this.setState({selectedEditData:row});
    }
    onDeleteClick = (row) =>{
        console.log('DeleteClick-------',row);
        this.setState({deleteDialog:true});
        this.setState({selectedEditData:row});
    }
    render() {
        console.log('AdminTable props:',this.props);
        console.log('adminData:',this.state.adminData);
        console.log('records:',this.state.records);

        const options = {
            page: this.state.currentPage,
            sizePerPage: 10,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationShowsTotal: this.renderShowsTotal.bind(this),
            onPageChange: this.pageChanged.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            onSortChange: this.sortChanged.bind(this),
        };

        return (
    //         <div>
    //       <div>
    //    <Button onClick={this.onAddClick}>Add Auditor</Button>
    //    <AdminModelPop
    //    opendialog={this.state.openDialog}
    //    dialogFor={this.state.dialogFor}
    //    selectedEditData={this.state.selectedEditData}
    //    close={this.closePopup}/>
    //           </div>
    //     <div>
    <div>
           <div class="pull-left">
       <Button onClick={this.onAddClick}>Add Auditor</Button>
       </div>
       <div class="pull-right"> 
        <Link to='/invoiceSearch'>
        <Button>Back</Button>
        </Link>
        </div>
        <br/>
<br/>
                 <div className='table'>
                    <BootstrapTable
                        data={this.props.auditorData ? this.props.auditorData.content:[]}
                        options={options}
                        pagination={true}
                         keyField={"id"}
                          fetchInfo={{ dataTotalSize: this.state.records }} 
                          remote={true}>
                        <TableHeaderColumn dataField='userId' dataAlign="center" dataSort={true} >User Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='searchFromDate' dataAlign="center" dataSort={true}>Invoice From Date</TableHeaderColumn>
                        <TableHeaderColumn dataField='searchToDate' dataAlign="center" dataSort={true}>Invoice To Date</TableHeaderColumn>
                        <TableHeaderColumn dataField='vatNumberFrom' dataAlign="center" dataSort={true}>Vat No. From</TableHeaderColumn>
                        <TableHeaderColumn dataField='accessFromDate' dataAlign="center" dataSort={true}>Access From Date</TableHeaderColumn>
                        <TableHeaderColumn dataField='accessToDate' dataAlign="center" dataSort={true}>Access To Date</TableHeaderColumn>
                       {/* <TableHeaderColumn  dataField='edit/delete'   dataFormat={(cell,row) =>this.columnFormatter('editFormatter',cell,row)} dataAlign="center">Edit/Delete</TableHeaderColumn> */}
                      {/* <TableHeaderColumn dataField='edit/delete' dataFormat={(cell,row)=>this.columnFormatter(cell,row)}>Edit/Delete</TableHeaderColumn> */}
                      <TableHeaderColumn dataField="button" dataFormat={this.buttonFunction} dataAlign="center">Edit</TableHeaderColumn>
                     </BootstrapTable>
                {/* </div>
        </div>
    </div> */}
    </div>
            <AdminModelPop
       opendialog={this.state.openDialog}
       dialogFor={this.state.dialogFor}
       selectedEditData={this.state.selectedEditData}
       close={this.closePopup}/>
       <AdminDeletePopup
       deleteDialog={this.state.deleteDialog}
       selectedEditData={this.state.selectedEditData}
       close={this.closePopup}
       />
            </div>

        )
    }
}
export default AdminTable;
